import { i as inject } from "../services/current-app.js";
import { c as createGlobalConfig, p as provideForCurrentApp, G as GLOBAL_CONFIG } from "../services/global-config/global-config.js";
function useGlobalConfig() {
  let injected = inject(GLOBAL_CONFIG);
  if (!injected) {
    injected = createGlobalConfig();
    provideForCurrentApp(injected);
  }
  return injected;
}
export {
  useGlobalConfig as u
};
//# sourceMappingURL=useGlobalConfig.js.map
